import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: "0px 16px 20px 16px",
				background: theme.palette.common.white
			},
			title: {
				textAlign: "center",
				padding: "0px 30px",
				"& > img": {
					width: "100%"
				}
			},
			body: {
				position: "relative",
				background:
					"linear-gradient(144.18deg, #E2FF6C -2.47%, rgba(255, 255, 255, 0) 61.87%)",
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: "20px 6px 6px 20px",
				marginTop: 16
			},
			logo: {
				background:
					"linear-gradient(151.74deg, #C3EB90 11%, #22AC93 90.84%)",
				borderRadius: "20px 0px 0px 20px",
				display: "flex",
				justifyContent: "center",
				alignItems: "center"
			},
			bgLogo: {
				backgroundRepeat: "no-repeat",
				backgroundSize: "120% 100%",
				width: "100%",
				height: "100%",
				borderRadius: "20px 0px 0px 20px"
			},
			program: {
				background: theme.palette.common.white,
				borderRadius: "20px 6px 6px 20px",
				padding: "10px 0px 10px 20px",
				marginLeft: -15
			},
			borderTitle: {
				borderBottom: `1px dashed ${theme.palette.grey[50]}`,
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				paddingBottom: 5
			},
			titleProgram: {
				fontSize: 14,
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				width: "90%",
				textOverflow: "ellipsis",
				overflow: "hidden",
				whiteSpace: "nowrap"
			},
			discription: {
				height: 45,
				textOverflow: "ellipsis",
				overflow: "hidden",
				whiteSpace: "nowrap",
				fontSize: 12,
				padding: "5px 0px",
				color: theme.palette.grey[50],
				lineHeight: "16px"
			},
			time: {
				display: "flex",
				marginTop: 10,
				fontSize: 12,
				alignItems: "center",
				color: theme.palette.grey[50],
				"& > img": {
					marginRight: 2
				}
			}
		}),
	{
		name: "ProgramCampaign",
		index: 1
	}
);

export default useStyles;
